//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ObjectCardWrapper from '../../components/Card/ObjectCardWrapper.vue'

export default {
  name: 'ObjectCardDialog',
  components: {
    ObjectCardWrapper
  },
  props: {
    objectId: {
      type: [String, Number],
      required: true
    },
    objectType: {
      type: String,
      required: true
    },
    objectParams: {
      type: Object,
      default: null
    },
    cardParams: {
      type: Object,
      default: null
    },
    objectData: {
      type: Object,
      default: null
    },
    typeKey: {
      type: String,
      default: null
    },
    subtypeKey: {
      type: String,
      default: null
    },
    headerHidden: { // -> local
      type: Boolean,
      default: false
    },
    closable: { // -> local
      type: Boolean,
      default: false
    },
    modeCustom: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    create: {
      type: Boolean,
      default: false
    },
    createConfig: {
      type: Object,
      default: null
    }
  },
  methods: {
    // following methods are REQUIRED ===
    show () {
      this.$refs.dialog.show()
    },
    hide () {
      this.$refs.dialog.hide()
    },
    // ===

    onDialogHide () {
      this.$emit('hide') // REQUIRED to be emitted, when QDialog emits "hide" event
      this.hide()
    },
    onOKClick () {
      this.$emit('ok') // REQUIRED; or with payload: this.$emit('ok', { ... })
      this.hide()
    },
    onCancelClick () {
      this.hide()
    },
    onCreated: function (objectId) {
      this.$emit('created', objectId)
    }
  }

}
